var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFiltersFilled = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2.131 3.836A.5.5 0 0 1 2.501 3H13.5a.5.5 0 0 1 .37.836l-4.234 4.52a.5.5 0 0 0-.135.341v3.469a.5.5 0 0 1-.222.416l-2 1.333A.5.5 0 0 1 6.5 13.5V8.697a.5.5 0 0 0-.135-.341l-4.234-4.52Z",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  fill: "currentColor"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgFiltersFilled);
export default ForwardRef;